import React, {useMemo, useState} from "react";
import {Table, Button, Flex, Tooltip, Modal, Space, Empty} from "antd";
import {
    EditOutlined,
    SearchOutlined,
    DeleteOutlined,
    ExclamationCircleOutlined, CheckCircleOutlined, CheckCircleFilled,
} from "@ant-design/icons";

import {toast} from "react-toastify";
import {axiosInstance} from "../../../api/axiosInstance";
import dayjs from "dayjs";

const TodoTable = ({
                       tableData,
                       fetchTodos,
                   }) => {
    const [arrow, setArrow] = useState("Show");
    const mergedArrow = useMemo(() => {
        if (arrow === "Hide") {
            return false;
        }

        if (arrow === "Show") {
            return true;
        }

        return {
            pointAtCenter: true,
        };
    }, [arrow]);

    const confirm = (id) => {
        Modal.confirm({
            title: "Potvrda",
            icon: <ExclamationCircleOutlined/>,
            content: "Jeste li sigurni da želite obrisati zadatak?",
            okText: "Da",
            cancelText: "Ne",
            centered: true,
            onOk: () => {
                axiosInstance.delete(`/api/v1/todo/${id}`)
                    .then(res => {
                        toast.success("Zadatak je uspješno obrisan!");
                        fetchTodos();
                    }).catch(ex => {
                    toast.error(`${ex.response.data.errorMessage}`);
                })
            },
        });
    };

    const rowClassName = (record, index) => {
        if (record.done) {
            return 'done';
        } else {
            return "not-done"
        }
    };

    return (
        <>
            { tableData && tableData.length > 0 ?
                <Table
                    rowClassName={rowClassName}
                    components={{
                        body: {
                            row: ({className, ...props}) => {
                                let tClassName = className.split(" ")[2]
                                let currentStyle;
                                switch (tClassName) {
                                    case 'done':
                                        currentStyle = {
                                            backgroundImage: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVQIW2NkYGCQBAAAIwAbDJgTxgAAAABJRU5ErkJggg==)",
                                            backgroundRepeat: "repeat-x",
                                            backgroundPosition: "50% 50%",
                                            color: 'black'
                                        };
                                        currentStyle = {
                                            textDecoration: 'line-through'
                                        }
                                        break;
                                    default:
                                        break;
                                }
                                return (
                                    <tr
                                        {...props}
                                        style={
                                            currentStyle
                                        }
                                    />
                                )
                            }
                        },
                    }}
                    scroll={{x: 700}}
                    size={"small"}
                    bordered={true}
                    rowKey={"id"}
                    columns={[
                        {
                            title: "Poruka",
                            dataIndex: "message",
                            key: "message",
                            width: "40%",
                            render: (value, record, index) => {
                                return <div style={{
                                    padding: '20px',
                                    width: '600px'
                                }}>{value ? value : "-"}</div>;
                            },
                        },
                        {
                            title: "Datum kreiranja zadatka",
                            dataIndex: "createdAt",
                            key: "createdAt",
                            align: "center",
                            render: (value, record, index) => {
                                return <p>{value ? dayjs(value).format("DD.MM.YYYY. HH:mm") : "-"}</p>;
                            },
                        },
                        {
                            title: "Rok završetka zadatka",
                            key: "deadlineDateTime",
                            align: "center",
                            render: (value, record, index) => {
                                console.log(record)
                                return <p>{record ?
                                    `${dayjs(record.deadlineDate).format("DD.MM.YYYY.")} ${record.deadlineTime}`
                                    : "-"}</p>;
                            },
                        },
                        {
                            title: "",
                            key: "operation",
                            //fixed: "right",
                            width: "150px",
                            render: (text, record, index) => (
                                <Flex vertical={false} gap={"4px"}>
                                    <Tooltip
                                        placement="top"
                                        title={
                                            <span>{!record.done ? "Postavi zadatak kao izvršen" : "Postavi zadatak kao neizvršen"}</span>}
                                        arrow={mergedArrow}
                                    >
                                        <Button
                                            type="text"
                                            size="large"
                                            icon={!record.done ? <CheckCircleOutlined/> :
                                                <CheckCircleFilled/>}
                                            onClick={() => {
                                                axiosInstance.patch(`/api/v1/todo/${record.id}`)
                                                    .then(res => {
                                                        fetchTodos();
                                                    })
                                            }}
                                            style={{color: 'green'}}
                                        />
                                    </Tooltip>
                                    <Tooltip
                                        placement="top"
                                        title={<span>Ukloni zadatak</span>}
                                        arrow={mergedArrow}
                                    >
                                        <Space>
                                            <Button
                                                type="text"
                                                size="large"
                                                danger
                                                icon={<DeleteOutlined/>}
                                                onClick={() => confirm(record.id)}
                                            />
                                        </Space>
                                    </Tooltip>
                                </Flex>
                            ),
                        },
                    ]}
                    dataSource={tableData}
                    pagination={false}
                ></Table> :
                <div style={{
                    display: 'flex', justifyContent: 'center', alignItems: 'center', height: '20vh'
                }}>
                    <Empty description={"Nije pronađen niti jedan zadatak na TODO listi."}/>
                </div>}
        </>
      )
}
export default TodoTable;
